import React from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import IconBtn from '../../../common/IconBtn';
import { updateProfile } from '../../../../services/operations/settingsAPI';

const genders = ["Male", "Female", "Non-Binary", "Prefer not to say", "Other"]

const EditProfile = () => {

    const {register, handleSubmit, formState:{errors}} = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {user} = useSelector((state) => state.profile);
    const {token} = useSelector((state) => state.auth);

    const submitProfileForm = (data) =>{
        try {
            dispatch(updateProfile(token, data));
        } catch (error) {
            console.log(error);
        }
    }
  return (
    <div>
        <form onSubmit={handleSubmit(submitProfileForm)}>
            <div className="my-10 flex flex-col gap-y-6 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12">
                <h2 className="text-lg font-semibold text-richblack-5">Profile Information</h2>
                <div className="flex flex-col gap-5 lg:flex-row">
                    {/* first name */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="firstName" className="lable-style">First Name</label>
                        <input type="text" name="firstName" id="firstName" placeholder='Enter First Name' className='form-style' 
                            defaultValue={user?.firstName}
                            {...register("firstName", {required:true})}
                        />
                        {
                            errors.firstName && (
                                <span className="-mt-1 text-[12px] text-yellow-100">Please enter your first name.</span>
                            )
                        }
                    </div>
                    
                    {/* last name */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="lastName" className="lable-style">Last Name</label>
                        <input type="text" name="lastName" id="lastName" placeholder='Enter Last Name' className='form-style' 
                            defaultValue={user?.lastName}
                            {...register("lastName", {required:true})}
                        />
                        {
                            errors.lastName && (
                                <span className="-mt-1 text-[12px] text-yellow-100">Please enter your last name.</span>
                            )
                        }
                    </div>
                </div>

                <div className="flex flex-col gap-5 lg:flex-row">
                    {/* dateOfBirth */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="dateOfBirth" className="lable-style">Date of Birth</label>
                        <input type="date" name="dateOfBirth" id="dateOfBirth"className='form-style' 
                            defaultValue={user?.additionalDetails?.dateOfBirth}
                            {...register("dateOfBirth",
                                {
                                    required:{
                                        value:true,
                                        message:"Please enter your Date of Birth",
                                    },
                                    max:{
                                        value: new Date().toISOString().split("T")[0],
                                        message:"Date of Birth can't be in future",
                                    }
                                }
                            )}
                        />
                        {
                            errors.dateOfBirth && (
                                <span className="-mt-1 text-[12px] text-yellow-100">{errors.dateOfBirth.message}</span>
                            )
                        }
                    </div>
                    
                    {/* gender */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="gender" className="lable-style">Gender</label>
                        <select type="text" name="gender" id="gender" className='form-style' 
                            defaultValue={user?.additionalDetails?.gender ? user?.additionalDetails?.gender : ""}
                            {...register("gender", {required:true})}
                        >
                            <option value="" disabled>Select your gender</option>
                            {
                                genders.map((ele, i)=>{
                                    return(
                                        <option value={ele} key={i}>{ele}</option>
                                    )
                                })
                            }
                        </select>
                        {
                            errors.gender && (
                                <span className="-mt-1 text-[12px] text-yellow-100">Please select your gender.</span>
                            )
                        }
                    </div>
                </div>

                <div className="flex flex-col gap-5 lg:flex-row">
                    {/* contactNumber */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="contactNumber" className="lable-style">Contact Number</label>
                        <input type="tel" name="contactNumber" id="contactNumber"className='form-style' placeholder="Enter Contact Number"
                            defaultValue={user?.additionalDetails?.contactNumber}
                            {...register("contactNumber",
                                {
                                    required:{
                                        value:true,
                                        message:"Please enter your Contact Number",
                                    },
                                    maxLength:{value: 12, message: "Invalid Contact Number"},
                                    minLength:{value: 8, message: "Invalid Contact Number"},
                                }
                            )}
                        />
                        {
                            errors.contactNumber && (
                                <span className="-mt-1 text-[12px] text-yellow-100">{errors.contactNumber.message}</span>
                            )
                        }
                    </div>
                    
                    {/* about */}
                    <div className="flex flex-col gap-2 lg:w-[48%]">
                        <label htmlFor="about" className="lable-style">About</label>
                        <input type="text" name="about" id="about" placeholder='Enter Bio Details' className='form-style' 
                            defaultValue={user?.additionalDetails?.about}
                            {...register("about", {required:true})}
                        />
                        {
                            errors.about && (
                                <span className="-mt-1 text-[12px] text-yellow-100">Please select your about.</span>
                            )
                        }
                    </div>
                </div>
            </div>
            
            <div className="flex justify-end gap-2">
                <button className='cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50'
                    onClick={()=> navigate("/dashboard/my-profile")}
                >
                    Cancel
                </button>
                <IconBtn type={"submit"} text={"Save"}/>
            </div>
        </form>
    </div>
  )
}

export default EditProfile
